import type { RouteRecordRaw } from 'vue-router';

export const usersRoutes: RouteRecordRaw[] = [
  {
    path: '/usuarios',
    name: 'usuarios',
    component: () => import('./views/UsersView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
];

export default usersRoutes;